var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingCorbIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.444 2.25H8.556C7.50113 2.24982 6.58736 2.98159 6.357 4.011L2.25 22.5C2.25 26.2279 5.27208 29.25 9 29.25C12.7279 29.25 15.75 26.2279 15.75 22.5C15.75 26.2279 18.7721 29.25 22.5 29.25C26.2279 29.25 29.25 26.2279 29.25 22.5C29.25 26.2279 32.2721 29.25 36 29.25C39.7279 29.25 42.75 26.2279 42.75 22.5C42.75 26.2279 45.7721 29.25 49.5 29.25C53.2279 29.25 56.25 26.2279 56.25 22.5C56.25 26.2279 59.2721 29.25 63 29.25C66.7279 29.25 69.75 26.2279 69.75 22.5L65.64 4.011C65.4119 2.98142 64.4985 2.24897 63.444 2.25Z",
    stroke: "#1F1F1F",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.25 69.75V38.25",
    stroke: "#1F1F1F",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 38.25V69.75",
    stroke: "#1F1F1F",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2468 51.75H24.2338C22.7608 51.7547 21.3834 52.4799 20.546 53.6918C19.7086 54.9036 19.5173 56.4485 20.0338 57.828L23.9578 68.289C24.2845 69.1664 25.1216 69.7488 26.0578 69.75H45.4378C46.3733 69.7462 47.209 69.1647 47.5378 68.289L51.4588 57.828C51.9761 56.4465 51.7835 54.8993 50.9433 53.6868C50.103 52.4744 48.722 51.7507 47.2468 51.75V51.75Z",
    stroke: "#3FB483",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4883 51.75L28.9883 40.5",
    stroke: "#3FB483",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9883 51.75L42.4883 40.5",
    stroke: "#3FB483",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 63V58.5",
    stroke: "#3FB483",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 63V58.5",
    stroke: "#3FB483",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCorbIcon);
export default __webpack_public_path__ + "static/media/shopping-corb-icon.ac5f558f68ed12b23e419607170dc659.svg";
export { ForwardRef as ReactComponent };